<script>
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { isLoading } from '@/store/loading';

export default {
  components: { Header, Footer },
  setup() {
    const route = useRoute();

    watch(
      isLoading,
      v => {
        console.log('@@@ isLoading:', v);
      },
      { immediate: true },
    );

    return { route, isLoading };
  },
  computed: {
    setDev() {
      return process.env.VUE_APP_SETTING;
    },
  },
};
</script>

<template>
  <div v-if="setDev === 'TEST'" class="test-server">테스트서버 입니다.</div>
  <Header v-if="route.path !== '/timeDeal'" />
  <div v-if="isLoading" class="page-loader">
    <div class="spinner"></div>
  </div>
  <router-view />
  <Footer />
</template>
